var map = {
	"./muviflex/fale_conosco.svg": "./assets/images/fale-conosco-float/muviflex/fale_conosco.svg",
	"./planalto/fale_conosco.svg": "./assets/images/fale-conosco-float/planalto/fale_conosco.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/fale-conosco-float sync recursive ^\\.\\/.*\\/fale_conosco\\.svg$";